import { daysUntil } from './grantStages';

export const REMINDER_OFFSET_CHOICES = [30, 14, 7, 3, 1];

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const CLOSED_STAGES = ['complete', 'declined'];

const remindersOn = (grant) => grant.reminders_enabled !== false && !CLOSED_STAGES.includes(grant.stage);

const isOpen = (milestone) => !milestone.done && milestone.key !== 'submission';

const offsetsAhead = (milestone, grant, today) => {
  const days = daysUntil(milestone.due_on, today);
  return (grant.reminder_offsets || []).filter((offset) => days - offset >= 0).sort((a, b) => b - a);
};

const shiftDate = (isoDate, days) => {
  const [year, month, day] = isoDate.substring(0, 10).split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day) + days * MS_PER_DAY).toISOString().substring(0, 10);
};

export function offsetLabel(offset) {
  return `${offset} ${offset === 1 ? 'day' : 'days'} before`;
}

export function reminderCellText(milestone, grant, today = new Date()) {
  if (!isOpen(milestone)) return '—';
  if (!remindersOn(grant)) return 'Off';
  const offsets = offsetsAhead(milestone, grant, today);
  if (offsets.length === 0) return 'No reminders before this deadline';
  return `${offsets.map((offset) => `${offset}d`).join(', ')} before`;
}

export function nextReminderOn(grant, today = new Date()) {
  if (!remindersOn(grant)) return null;
  const dates = (grant.milestones || [])
    .filter((milestone) => milestone.due_on && isOpen(milestone))
    .flatMap((milestone) => offsetsAhead(milestone, grant, today).map((offset) => shiftDate(milestone.due_on, -offset)));
  return dates.length ? dates.sort()[0] : null;
}

export function recipientNames(grant, owners) {
  const ids = [grant.owner_team_membership_id, ...(grant.reminder_team_membership_ids || [])].filter(Boolean);
  return [...new Set(ids.map(String))]
    .map((id) => owners.find((owner) => String(owner.value) === id))
    .filter(Boolean)
    .map((owner) => owner.label);
}
